/**
 * @fileoverview Helper function to check if the url contains
 * share link params for any version (v1 or v2) or short link params.
 *
 * NOTE: Keep as little dependencies as possible
 */

import {
  SHARE_LINK_PARAM,
  SHORT_LINK_PARAM,
  WHITELIST_KEYS,
} from '../constants'

/**
 * Quick check if the url contains share link params for any version (v1 or v2)
 * @param url
 * @returns
 */
export const quickCheckShareLinkParams = (url: string) => {
  return (
    url.includes(SHARE_LINK_PARAM) ||
    url.includes(SHORT_LINK_PARAM) ||
    WHITELIST_KEYS.some((key) => url.includes(key))
  )
}
